<template>
      <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
    <div v-else class="">

        <Banner
            :background="(item.image) ? item.image.url: ''"
            :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.title : item.title : ''"
            :subtitle="(!pgLoading) ? ($i18n.locale == 'en') ? item.title : item.title : ''">

        </Banner>

         <div class="rules-area ptb-100">
            <div class="container">
                <p v-if="!pgLoading"
                 v-html=" item.body " ></p>
            </div>
        </div>
        
        <section class="privacy-policy ptb-100" :class="(locale == 'ar') ? 'rtl' : 'ltr'">
          <div v-if="pgLoading" class="container">
            <div class="single-privacy">
              <h3 class="mt-0 webkit-animation webkit-50-100"></h3>
              <p class="webkit-animation webkit-100-500"></p>
            </div>
          </div>
          <div v-if="!pgLoading" class="container">
            <div class="single-privacy">
              <p v-html="row.body"></p>
            </div>
          </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'List',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data(){
        return {
            //
            item: '',
            refs: 'pages/terms-condition',
            pgLoading: true,

            locale: 'ar',
            row: '',
        }
    },
    mounted() {},
    created() {
        //
         if (localStorage.getItem("locale")) {
            this.locale = localStorage.getItem("locale");
        }
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            window.scrollTo(0,0);
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL+'/'+this.refs,
                method: 'GET',
                data: {},
                params: {
                    locale: this.locale
                }        
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;
                this.item = res.data.row;
                this.row = res.data.row;

            })
            .catch(() => {
                //
            })
            .finally(() => {});
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
